<template>
<ValidationObserver ref="observer">
  <form ref="add_business_unit_form" @submit.prevent="addPool">

    <md-card>
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
              <validation-provider rules="harus" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Eshed Name</label>
                  <md-input v-model="pool_name" required/>
                  <validation-error :errors="apiValidationErrors.pool_name" />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
              <validation-provider rules="harus" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Eshed Address</label>
                  <md-textarea v-model="pool_address" md-autogrow maxlength="100" md-counter="100"></md-textarea>

                  <validation-error :errors="apiValidationErrors.pool_address" />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
        </div>


        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
              <validation-provider rules="harus" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Eshed Head</label>
                  <md-select v-model="pool_head_id" required>
                    <md-option v-for="option in options_user_list" :key="option.value" :value="option.id">
                      {{ option.name }}
                    </md-option>
                  </md-select>
                  <validation-error
                    :errors="apiValidationErrors.pool_head_id"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
        </div>

        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
              <validation-provider rules="harus" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Workshop Head</label>
                  <md-select v-model="pool_workshop_head_id" required>
                    <md-option v-for="option in options_workshop_head_list" :key="option.value" :value="option.id">
                      {{ option.name }}
                    </md-option>
                  </md-select>
                  <validation-error
                    :errors="apiValidationErrors.pool_workshop_head_id"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
        </div>
        
      </md-card-content>

      <md-card-actions>
        <md-button class="md-info md-dense" @click="addConfirmation">
          Submit
        </md-button>
      </md-card-actions>
    </md-card>
  </form>
</ValidationObserver>
  
</template>

<script>
import {ValidationError} from "@/components";
import formMixin from "@/mixins/form-mixin";
import { extend , validate, localize , ValidationObserver } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2';
import Swal from 'sweetalert2';

Vue.use(VueSweetalert2);

// mengirim pesan error ketika required field tidak diisi
extend('harus', {
  ...required,
  message: 'Field is required'
});
  
  export default {
     name: "add-pool",

    props: {
      data: Object
    },

    components: {ValidationError, ValidationObserver},

    mixins: [formMixin],

    data: () => ({
      pool_name: null,
      pool_head_name: null,
      pool_head_id: null,
      pool_workshop_head_id: null,
      options_user_list: null,
      options_workshop_head_list: null,
      pool_address: null
    }),

    created() {
      this.getPoolHead();
      this.getWorkshopHead();
    },

  
    methods: {

      async getPoolHead(){
        await this.$store.dispatch("users/list_pool_head")
        this.options_user_list = await this.$store.getters["users/list"]
      },

      async getWorkshopHead(){
        await this.$store.dispatch("users/list_workshop_head")
        this.options_workshop_head_list = await this.$store.getters["users/list"]
      },


     // validasi menggunakan sweetalert  sebelum menambah data
    async addConfirmation() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return
      }
    Swal.fire({
        title: 'Are you sure?',
        text: 'The data will be saved!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Save it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
        }).then((result) => {
          if (result.value){
            this.addPool()
          }
        });
    },


    // fungsi add data
      async addPool() {
       

        const data = {
          type: "workshop_pools",
          // client_no: this.client_no,
          pool_name: this.pool_name,
          pool_head_id: this.pool_head_id,
          pool_workshop_head_id: this.pool_workshop_head_id,
          pool_address : this.pool_address
        }


        try {
        await this.$store.dispatch("workshop_pool/add", data);
        await this.$store.dispatch(
          "alerts/success",
          "Successfully registered."
        );
        this.$parent.$parent.modalCloseAdd();
      } catch (e) {
        // await this.$store.dispatch(
        //   "alerts/error",
        //   "Oops, something went wrong"
        // );
        console.log(e);
        this.setApiValidation(e.response.data.errors);
      }

      }
    }
  };
</script>
